import { render, staticRenderFns } from "./Eixos.vue?vue&type=template&id=76e24242&scoped=true&"
import script from "./Eixos.vue?vue&type=script&lang=js&"
export * from "./Eixos.vue?vue&type=script&lang=js&"
import style0 from "./Eixos.vue?vue&type=style&index=0&id=76e24242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e24242",
  null
  
)

export default component.exports